export default {
    navigationBarTitleText: '线下获客列表',
};
